var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.03 18.64C7.85701 17.3023 5.83757 15.7298 4.00801 13.951C2.71859 12.6666 1.73849 11.1055 1.14201 9.386C0.0690069 6.036 1.32301 2.207 4.84001 1.074C5.75179 0.779858 6.72092 0.709166 7.66573 0.867883C8.61055 1.0266 9.50338 1.41008 10.269 1.986V1.986C11.0341 1.41204 11.9255 1.02972 12.8686 0.871043C13.8118 0.71237 14.7793 0.781965 15.69 1.074C19.207 2.207 20.469 6.036 19.397 9.386C18.8012 11.1073 17.8211 12.6701 16.531 13.956C14.7012 15.7331 12.6818 17.3038 10.509 18.64L10.274 18.786L10.03 18.64Z",
    stroke: "#d00d65",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_87"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.539,
    height: 19.536,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.7c9f832c5934ef057bf179ec62365a35.svg";
export { ForwardRef as ReactComponent };